class UserProfile {
    constructor() {
        this.id = null;
        this.city = null;
        this.country = null;
        this.email = null;
        this.firstname = null;
        this.fullname = null;
        this.homePage = null;
        this.initials = null;
        this.lastname = null;
        this.libraryId = null;
        this.preferredCulture = null;
        this.profilePicture72Url = null;
        this.profilePicture360Url = null;
        this.sendMarketingEmail = null;
        this.state = null;
    }
}
const keysOfUserProfile = ["id", "city", "country", "email", "firstname", "fullname", "homePage", "initials", "lastname", "libraryId", "preferredCulture", "profilePicture72Url", "profilePicture360Url", "sendMarketingEmail", "state"];

export { UserProfile, keysOfUserProfile };
